import React from "react";
import Select from "react-select";
import yardsData from "../assets/yards.json";

export default function YardDropdown({ value, onChange, className, filteredYards = null }) {
  // If filteredYards is provided, only show those yards
  const yardsToShow = filteredYards && filteredYards.length > 0
    ? yardsData.filter(yard => filteredYards.includes(String(yard.Yard)))
    : yardsData;
  
  const options = [
    { value: "", label: "All Yards" },
    ...yardsToShow.map(yard => ({
      // Use yard number as value (source of truth from yards.json)
      value: String(yard.Yard),
      label: `Yard ${yard.Yard} - ${yard.City}, ${yard.State}`
    }))
  ];

  const selectedOption = options.find(opt => opt.value === value) || options[0];

  return (
    <Select
      options={options}
      value={selectedOption}
      onChange={(selectedOption) => onChange(selectedOption?.value || "")}
      placeholder="Search yards..."
      isClearable
      isSearchable
      className={className || "w-full sm:w-1/3"}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        menu: base => ({ ...base, zIndex: 9999 }),
      }}
    />
  );
}

